module.exports = __webpack_public_path__ + "img/button-doctormovement_TC_1.5c6ed093.png";